export default function(
  state = {
    deletePortletInstance: "",
    currentLayout: {},
    currentLayoutPortlets: [],
    layouts: [],
    tabs: [],
    selectedTab: 0,
    firstLoad: true,
    edit: true,
    teamLayoutEditMode: false,
  },
  action
) {
  let newTabs = [];
  let newLayouts = [];
  switch (action.type) {
    case "SET_EDIT":
      return Object.assign({}, state, {
        edit: action.edit,
      });
    case "SET_TEAM_LAYOUT_EDIT_MODE":
      return Object.assign({}, state, {
        teamLayoutEditMode: action.teamLayoutEditMode,
      });
    case "CHANGE_SELECTED":
      let layoutToSelect = action.selected === 0 
      ? state.layouts[action.selected]
      : state.layouts.filter((l) => l.id === action.selected)[0]
      return Object.assign({}, state, {
        selectedTab: action.selected,
        currentLayout: {...layoutToSelect},
        teamLayoutEditMode: false,
      });
    case "DELETE_PORTLET_FROM_LAYOUT":
      return Object.assign({}, state, {
        deletePortletInstance: action.deletePortletInstance,
      });
    // case 'ADD_PORTLET_TO_LAYOUT':
    //     return Object.assign({}, state, {
    //         addPortlet: action.addPortlet
    //     });
    case "ADD_LAYOUT":
      newLayouts = state.layouts.slice(0);
      newLayouts.push(action.layout);
      newTabs = state.tabs.slice(0);
      newTabs.push({title: action.layout.title, id: action.layout.id});
      return Object.assign({}, state, {
        layouts: newLayouts,
        tabs: newTabs, // New layouts list,
      });
    case "RENAME_TAB":
      newTabs = state.tabs.slice(0);
      newTabs[state.selectedTab].title = action.title;
      return Object.assign({}, state, {
        tabs: newTabs, // New tabs list
      });
    case "REMOVE_LAYOUT":
      let selected = state.selectedTab;
      newTabs = state.tabs.slice(0);
      newTabs.splice(selected, 1);
      newLayouts = state.layouts.slice(0);
      newLayouts.splice(selected, 1);
      return Object.assign({}, state, {
        layouts: newLayouts,
        tabs: newTabs,
        currentLayout: state.layouts[0],
        selectedTab: 0, // New tabs list
        teamLayoutEditMode: false,
      });
    case "SET_TABS":
      return Object.assign({}, state, {
        tabs: action.tabs,
      });
    case "SET_LAYOUTS":
      // if (areLayoutsEqual(action.layouts, state.layouts)) return state;
      newTabs = [];
      for (let i = 0; i < action.layouts.length; i++) {
        newTabs.push({title: action.layouts[i].title, id: action.layouts[i].id});
      }
      newLayouts = [];
      for (let i = 0; i < action.layouts.length; i++) {
        newLayouts.push({
          ...action.layouts[i],
          selected: state.selectedTab === i,
        });
      }
      if (!state.firstLoad) {
        changeURL(action.layouts, 0);
      }
      let current = state.selectedTab === 0 
        ? action.layouts[state.selectedTab]
        : action.layouts.filter((l) => l.id === state.selectedTab)[0]
      return Object.assign({}, state, {
        layouts: newLayouts,
        tabs: newTabs,
        currentLayout: {
          ...current,
          selected: true,
        },
        firstLoad: false, // New layouts list
        // teamLayoutEditMode: false,
      });
    case "UPDATE_LAYOUTS":
      // if (areLayoutsEqual(action.layouts, state.layouts)) return state;
      newLayouts = [];
      for (let i = 0; i < action.layouts.length; i++) {
        newLayouts.push({
          ...action.layouts[i],
          selected: state.selectedTab === i ,
        });
      }
      return Object.assign({}, state, {
        layouts: newLayouts,
        firstLoad: false,
      });
    default:
      return state;
  }
}
function areLayoutsEqual(layouts1, layouts2) {
  var equal = require("deep-equal");
  return equal(layouts1, layouts2) ? true : false;
};
function changeURL(layouts, selected) {
  // if (layouts.length > 0) {
  //     let evt = new CustomEvent('changeURL', {
  //         detail: {
  //             layoutid: layouts[selected].object.layoutId,
  //             page: "layout"
  //         }
  //     });
  //     window.dispatchEvent(evt);
  // }
}
